import { sentryConfig } from '../../sentry.config';
import { dropThirdPartyErrors } from './sentryEventFilter';

type SentryModule = typeof import('./sentryClientSdk');

/**
 * Sentry im Browser, erst nach dem ersten Paint geladen (FE-4984). Das SDK liegt dadurch in einem
 * eigenen Chunk, der nicht mit dem LCP konkurriert. Fehler vor der Initialisierung sammeln die
 * Listener aus instrumentation-client.ts; sie landen ueber captureException in derselben Queue.
 *
 * Im Browser gibt es nur NEXT_PUBLIC_*-Variablen, die beim Build eingesetzt werden. Der DSN ist
 * oeffentlich (er steht in jedem Browser-Bundle), das Environment setzt deployJobserver.yml per
 * Build-Argument. Ohne Environment (lokal) bleibt Sentry im Browser aus und das SDK wird nie geladen.
 */
const STELLENPORTAL_DSN =
  'https://a80e8d29a100aa99e055db718e170dc8@o4507536703815680.ingest.de.sentry.io/4510160287170640';

const environment = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT;

let sentry: SentryModule | null = null;
let loading: Promise<SentryModule> | null = null;

export const isSentryEnabled = (): boolean => Boolean(environment);

export const loadSentry = (): Promise<SentryModule | null> => {
  if (!environment) return Promise.resolve(null);
  if (!loading) {
    loading = import('./sentryClientSdk').then((module) => {
      module.init({
        ...sentryConfig,
        dsn: sentryConfig.dsn ?? STELLENPORTAL_DSN,
        environment,
        beforeSend: dropThirdPartyErrors,
      });
      sentry = module;
      return module;
    });
  }
  return loading;
};

export const captureException = (error: unknown): void => {
  if (!environment) return;
  void loadSentry().then((module) => module?.captureException(error));
};

export const captureRouterTransitionStart: SentryModule['captureRouterTransitionStart'] = (href, navigationType) => {
  sentry?.captureRouterTransitionStart(href, navigationType);
};
